export default __webpack_public_path__ + "static/media/shariah.17a220f4.svg";